"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletPOIRequester = void 0;
const poi_node_request_1 = require("./poi-node-request");
const shared_models_1 = require("@railgun-community/shared-models");
class WalletPOIRequester {
    poiNodeRequest;
    constructor(poiNodeURLs) {
        this.poiNodeRequest = (0, shared_models_1.isDefined)(poiNodeURLs)
            ? new poi_node_request_1.POINodeRequest(poiNodeURLs)
            : undefined;
    }
    async validateRailgunTxidMerkleroot(txidVersion, chain, tree, index, merkleroot) {
        if (!this.poiNodeRequest) {
            return false;
        }
        return this.poiNodeRequest.validateRailgunTxidMerkleroot(txidVersion, chain, tree, index, merkleroot);
    }
    async getLatestValidatedRailgunTxid(txidVersion, chain) {
        if (!this.poiNodeRequest) {
            return { txidIndex: undefined, merkleroot: undefined };
        }
        const txidStatus = await this.poiNodeRequest.getLatestValidatedRailgunTxid(txidVersion, chain);
        return {
            txidIndex: txidStatus.validatedTxidIndex,
            merkleroot: txidStatus.validatedMerkleroot,
        };
    }
}
exports.WalletPOIRequester = WalletPOIRequester;
